export const INIT_REPORTS = 'reports/INIT_REPORTS';
export const CHANGE_REPORTS_SORT = 'reports/CHANGE_REPORTS_SORT';
export const CHANGE_REPORTS_FILTER = 'reports/CHANGE_REPORTS_FILTER';
export const CHANGE_REPORTS_PAGE = 'reports/CHANGE_REPORTS_PAGE';
export const CHANGE_REPORTS_PER_PAGE = 'reports/CHANGE_REPORTS_PER_PAGE';
export const CHANGE_REPORTS_SEARCH = 'reports/CHANGE_REPORTS_SEARCH';
export const TOGGLE_REPORT_SELECTED = 'reports/TOGGLE_REPORT_SELECTED';
export const TOGGLE_REPORT_SELECT_ALL = 'reports/TOGGLE_REPORT_SELECT_ALL';



// WEBPACK FOOTER //
// ./src/modules/reports/reports.actionTypes.js